import httpClient from '../../utilities/http/http-client';

const endPoint = '/v1/web/admin';

export default {
  getData(params = {}) {
    return httpClient.post(endPoint + '/dashboard');
  },
};
